export {hook as default} from '@shopify/cli-kit/node/hooks/postrun'
